import { useCallback } from 'react';
import { FddmServiceFactory } from '@/modules/canvas/services/Floorplan/FddmServiceFactory';
import { useResetStores } from '@/modules/common/hooks';

export const useHome = () => {
  const { resetStores } = useResetStores();

  const goHome = useCallback(async () => {
    let debounce: ReturnType<typeof setTimeout> | null = null;
    const debounceDelay = 100;
    FddmServiceFactory.getInstance().createFddmService().triggerAutosave();
    const model = FddmServiceFactory.getInstance().createFddmService().getModel();
    resetStores();
    if (debounce) clearTimeout(debounce);
    debounce = setTimeout(async () => {
      window.location.href = `/${model.metaData.projectId}`;
    }, debounceDelay);
  }, [resetStores]);

  return {
    goHome,
  };
};
